import {
  LST_CARGO_LABELS,
  LST_CARGO_ORDER,
  resolveLstCargoFromContext,
  type LstCargo,
} from '../types';
import type { LstTemplate } from '../types';
import { countTemplatesByScope } from './lstTemplateScope';

/** Hierarquia ordinal LST — maior = mais autoridade na governança de TPL. */
export const LST_CARGO_RANK: Record<LstCargo, number> = {
  apoio: 0,
  lider: 1,
  supervisor: 2,
  coordenador: 3,
  gerente: 4,
  diretor: 5,
};

/**
 * Cargos que o usuário logado pode visualizar/gerenciar no cadastro de rotinas.
 * Gestores enxergam o próprio nível e todos os inferiores; admin vê todos (exceto apoio).
 */
export function getManageableLstCargos(
  actorCargo: LstCargo,
  roleName?: string | null,
  options?: { isAdmin?: boolean },
): LstCargo[] {
  const isAdmin = options?.isAdmin ?? false;
  const refined = resolveLstCargoFromContext(actorCargo, roleName);
  const pool = LST_CARGO_ORDER.filter((c) => c !== 'apoio');

  if (isAdmin) return pool;

  const actorRank = LST_CARGO_RANK[refined] ?? LST_CARGO_RANK.lider;
  return pool.filter((c) => LST_CARGO_RANK[c] <= actorRank);
}

export function canManageLstCargo(
  actorCargo: LstCargo,
  targetCargo: LstCargo,
  roleName?: string | null,
  isAdmin = false,
): boolean {
  if (isAdmin) return targetCargo !== 'apoio';
  const manageable = getManageableLstCargos(actorCargo, roleName, { isAdmin });
  return manageable.includes(targetCargo);
}

export function formatConfigScopeSummary(
  templates: LstTemplate[],
  cargo: LstCargo,
  departmentName?: string | null,
): string {
  const { cargo: cargoCount, individual, total } = countTemplatesByScope(templates);
  const cargoLabel = LST_CARGO_LABELS[cargo];
  const countLabel = `${total} rotina${total !== 1 ? 's' : ''} cadastrada${total !== 1 ? 's' : ''} para o cargo ${cargoLabel}`;
  const breakdown =
    individual > 0
      ? ` (${cargoCount} cargo · ${individual} individual${individual !== 1 ? 'is' : ''})`
      : '';
  const base = `${countLabel}${breakdown}`;
  if (departmentName) return `${base} · Setor ${departmentName}`;
  return base;
}
